import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { SearchSelect } from '../../search_select'
import { useGetWhsUkCoursesQuery } from '../../../api/courses'

export const Step1WhsUk = ({ onCourseSelect }) => {
  const [searchQuery, setSearchQuery] = useState('')

  const { data: options, isLoading } = useGetWhsUkCoursesQuery(
    { q: searchQuery },
    { skip: !searchQuery }
  )

  return (
    <div>
      <div className="courses-modal-dropdown-label add-margin-top-10">
        {window.I18n.t('whs_uk.courses.popup.select_course')}
      </div>
      <SearchSelect
        placeholder={window.I18n.t('whs_uk.courses.popup.select_course')}
        handleSearchChange={setSearchQuery}
        handleSelectChange={(value, label) => onCourseSelect(value, label)}
        options={options}
        isLoading={isLoading}
      />
      <div className="btsp_notices add-margin-top-20">
        {window.I18n.t('courses.crs.popup.type_few_characters')}
      </div>
    </div>
  )
}

Step1WhsUk.propTypes = {
  onCourseSelect: PropTypes.func.isRequired,
}
